// extracted by mini-css-extract-plugin
module.exports = {"root":"IconSocialMediaTwitter_root__24iXV"};